export const GLOBAL_LOADER = 'GLOBAL_LOADER';
export const GLOBAL_LOADER_RES = 'GLOBAL_LOADER_RES';

export const DO_LOGIN = 'DO_LOGIN';
export const DO_LOGIN_RES = 'DO_LOGIN_RES';

export const DO_REGISTER = 'DO_REGISTER';
export const DO_REGISTER_RES = 'DO_REGISTER_RES';

export const DO_MENUCATEGORY = 'DO_MENUCATEGORY';
export const DO_MENUCATEGORY_RES = 'DO_MENUCATEGORY_RES';

export const DO_FEATUREPRODUCT = 'DO_FEATUREPRODUCT';
export const DO_FEATUREPRODUCT_RES = 'DO_FEATUREPRODUCT_RES';

export const DO_NEWPRODUCTLISTING = 'DO_NEWPRODUCTLISTING';
export const DO_NEWPRODUCTLISTING_RES = 'DO_NEWPRODUCTLISTING_RES';

export const DO_PRODUCTLISTING = 'DO_PRODUCTLISTING';
export const DO_PRODUCTLISTING_RES = 'DO_PRODUCTLISTING_RES';

export const DO_PRODUCTVIEW = 'DO_PRODUCTVIEW';
export const DO_PRODUCTVIEW_RES = 'DO_PRODUCTVIEW_RES';

export const DO_ADDTOCART = 'DO_ADDTOCART';
export const DO_ADDTOCART_RES = 'DO_ADDTOCART_RES';

export const DO_CARTLIST = 'DO_CARTLIST';
export const DO_CARTLIST_RES = 'DO_CARTLIST_RES';

export const DO_CHECKOUTDETAILS = 'DO_CHECKOUTDETAILS';
export const DO_CHECKOUTDETAILS_RES = 'DO_CHECKOUTDETAILS_RES';

export const DO_REMOVECARTITEM = 'DO_REMOVECARTITEM';
export const DO_REMOVECARTITEM_RES = 'DO_REMOVECARTITEM_RES';

export const DO_ADDNEWADDRESS = 'DO_ADDNEWADDRESS';
export const DO_ADDNEWADDRESS_RES = 'DO_ADDNEWADDRESS_RES';

export const DO_SHOWADDRESSLIST = 'DO_SHOWADDRESSLIST';
export const DO_SHOWADDRESSLIST_RES = 'DO_SHOWADDRESSLIST_RES';

export const DO_PLACEORDER = 'DO_PLACEORDER';
export const DO_PLACEORDER_RES = 'DO_PLACEORDER_RES';

export const DO_DELETEADDRESS = 'DO_DELETEADDRESS';
export const DO_DELETEADDRESS_RES = 'DO_DELETEADDRESS_RES';

export const DO_ORDERHISTORYLIST = 'DO_ORDERHISTORYLIST';
export const DO_ORDERHISTORYLIST_RES = 'DO_ORDERHISTORYLIST_RES';

export const DO_PROFILEDETAILSLIST = 'DO_PROFILEDETAILSLIST';
export const DO_PROFILEDETAILSLIST_RES = 'DO_PROFILEDETAILSLIST_RES';

export const DO_PROFILEDATAUPDATE = 'DO_PROFILEDATAUPDATE';
export const DO_PROFILEDATAUPDATE_RES = 'DO_PROFILEDATAUPDATE_RES';

export const DO_CHANGEPASSWORD = 'DO_CHANGEPASSWORD';
export const DO_CHANGEPASSWORD_RES = 'DO_CHANGEPASSWORD_RES';

export const DO_FORGOTPASSWORD = 'DO_FORGOTPASSWORD';
export const DO_FORGOTPASSWORD_RES = 'DO_FORGOTPASSWORD_RES';

export const DO_VERIFYPASSWORD = 'DO_VERIFYPASSWORD';
export const DO_VERIFYPASSWORD_RES = 'DO_VERIFYPASSWORD_RES';

export const DO_VARIABLEPRODUCTDETAILS = 'DO_VARIABLEPRODUCTDETAILS';
export const DO_VARIABLEPRODUCTDETAILS_RES = 'DO_VARIABLEPRODUCTDETAILS_RES';

export const DO_CARTUPDATE = 'DO_CARTUPDATE';
export const DO_CARTUPDATE_RES = 'DO_CARTUPDATE_RES';

export const DO_IMAGEUPLOADCUSTOMIZE = 'DO_IMAGEUPLOADCUSTOMIZE';
export const DO_IMAGEUPLOADCUSTOMIZE_RES = 'DO_IMAGEUPLOADCUSTOMIZE_RES';

export const DO_SEARCHINGLIST = 'DO_SEARCHINGLIST';
export const DO_SEARCHINGLIST_RES = 'DO_SEARCHINGLIST_RES';

export const DO_MENCUSTOMIZE = 'DO_MENCUSTOMIZE';
export const DO_MENCUSTOMIZE_RES = 'DO_MENCUSTOMIZE_RES';

export const DO_MOBILECUSTOMIZE = 'DO_MOBILECUSTOMIZE';
export const DO_MOBILECUSTOMIZE_RES = 'DO_MOBILECUSTOMIZE_RES';

export const DO_GETMOBILELIST = 'DO_GETMOBILELIST';
export const DO_GETMOBILELIST_RES = 'DO_GETMOBILELIST_RES';

export const DO_WOMENCUSTOMIZE = 'DO_WOMENCUSTOMIZE';
export const DO_WOMENCUSTOMIZE_RES = 'DO_WOMENCUSTOMIZE_RES';

export const DO_KIDSCUSTOMIZE = 'DO_KIDSCUSTOMIZE';
export const DO_KIDSCUSTOMIZE_RES = 'DO_KIDSCUSTOMIZE_RES';

export const DO_EMAILSUBSCRIBE = 'DO_EMAILSUBSCRIBE';
export const DO_EMAILSUBSCRIBE_RES = 'DO_EMAILSUBSCRIBE_RES';

export const DO_CONTACTFORM = 'DO_CONTACTFORM';
export const DO_CONTACTFORM_RES = 'DO_CONTACTFORM_RES';

export const DO_ORDERTRACKING = 'DO_ORDERTRACKING';
export const DO_ORDERTRACKING_RES = 'DO_ORDERTRACKING_RES';

export const DO_SUBCATLISTBYCATEGORY = 'DO_SUBCATLISTBYCATEGORY';
export const DO_SUBCATLISTBYCATEGORY_RES = 'DO_SUBCATLISTBYCATEGORY_RES';

export const DO_COMBOCUSTOMIZE = 'DO_COMBOCUSTOMIZE';
export const DO_COMBOCUSTOMIZE_RES = 'DO_COMBOCUSTOMIZE_RES';

export const DO_ADDTOCARTCOMBO = 'DO_ADDTOCARTCOMBO';
export const DO_ADDTOCARTCOMBO_RES = 'DO_ADDTOCARTCOMBO_RES';

export const DO_PRODUCTCOUPLECOMBODATA = 'DO_PRODUCTCOUPLECOMBODATA';
export const DO_PRODUCTCOUPLECOMBODATA_RES = 'DO_PRODUCTCOUPLECOMBODATA_RES';

export const DO_VARIABLECOUPLECOMBODATA = 'DO_VARIABLECOUPLECOMBODATA';
export const DO_VARIABLECOUPLECOMBODATA_RES = 'DO_VARIABLECOUPLECOMBODATA_RES';

export const DO_HOMEPAGEBANNER = 'DO_HOMEPAGEBANNER';
export const DO_HOMEPAGEBANNER_RES = 'DO_HOMEPAGEBANNER_RES';

export const DO_CORPORATEDEALSFORM = 'DO_CORPORATEDEALSFORM';
export const DO_CORPORATEDEALSFORM_RES = 'DO_CORPORATEDEALSFORM_RES';

export const DO_CHECKPROMOCODE = 'DO_CHECKPROMOCODE';
export const DO_CHECKPROMOCODE_RES = 'DO_CHECKPROMOCODE_RES';

export const DO_WALLETTRANSATIONLIST = 'DO_WALLETTRANSATIONLIST';
export const DO_WALLETTRANSATIONLIST_RES = 'DO_WALLETTRANSATIONLIST_RES';

export const DO_CORPORATEKITSLISTING = 'DO_CORPORATEKITSLISTING';
export const DO_CORPORATEKITSLISTING_RES = 'DO_CORPORATEKITSLISTING_RES';

export const DO_CORPORATECUSTOMIZEPRODUCTLISTING = 'DO_CORPORATECUSTOMIZEPRODUCTLISTING';
export const DO_CORPORATECUSTOMIZEPRODUCTLISTING_RES = 'DO_CORPORATECUSTOMIZEPRODUCTLISTING_RES';

export const DO_CORPORATEPRODUCTVIEW = 'DO_CORPORATEPRODUCTVIEW';
export const DO_CORPORATEPRODUCTVIEW_RES = 'DO_CORPORATEPRODUCTVIEW_RES';

export const DO_CORPORATEADDTOCART = 'DO_CORPORATEADDTOCART';
export const DO_CORPORATEADDTOCART_RES = 'DO_CORPORATEADDTOCART_RES';

export const DO_CORPORATECARTLIST = 'DO_CORPORATECARTLIST';
export const DO_CORPORATECARTLIST_RES = 'DO_CORPORATECARTLIST_RES';

export const DO_CORPORATECARTUPDATE = 'DO_CORPORATECARTUPDATE';
export const DO_CORPORATECARTUPDATE_RES = 'DO_CORPORATECARTUPDATE_RES';

export const DO_CORPORATEPRODUCTREMOVE = 'DO_CORPORATEPRODUCTREMOVE';
export const DO_CORPORATEPRODUCTREMOVE_RES = 'DO_CORPORATEPRODUCTREMOVE_RES';

export const DO_ALTTEXT = 'DO_ALTTEXT';
export const DO_ALTTEXT_RES = 'DO_ALTTEXT_RES';

export const DO_CORPORATESHOWADDRESSLIST = 'DO_CORPORATESHOWADDRESSLIST';
export const DO_CORPORATESHOWADDRESSLIST_RES = 'DO_CORPORATESHOWADDRESSLIST_RES';

export const DO_CORPORATEADDADDRESS = 'DO_CORPORATEADDADDRESS';
export const DO_CORPORATEADDADDRESS_RES = 'DO_CORPORATEADDADDRESS_RES';

export const DO_CORPORATEDELETEADDRESS = 'DO_CORPORATEDELETEADDRESS';
export const DO_CORPORATEDELETEADDRESS_RES = 'DO_CORPORATEDELETEADDRESS_RES';

export const DO_CORPORATECHECKOUTDETAILS = 'DO_CORPORATECHECKOUTDETAILS';
export const DO_CORPORATECHECKOUTDETAILS_RES = 'DO_CORPORATECHECKOUTDETAILS_RES';

export const DO_CORPORATEPROMOCODE = 'DO_CORPORATEPROMOCODE';
export const DO_CORPORATEPROMOCODE_RES = 'DO_CORPORATEPROMOCODE_RES';

export const DO_CORPORATEPLACEORDER = 'DO_CORPORATEPLACEORDER';
export const DO_CORPORATEPLACEORDER_RES = 'DO_CORPORATEPLACEORDER_RES';

export const DO_CORPORATEORDERHISTORYLIST = 'DO_CORPORATEORDERHISTORYLIST';
export const DO_CORPORATEORDERHISTORYLIST_RES = 'DO_CORPORATEORDERHISTORYLIST_RES';

export const DO_CORPORATECUSTOMIZEPRODUCTVIEW = 'DO_CORPORATECUSTOMIZEPRODUCTVIEW';
export const DO_CORPORATECUSTOMIZEPRODUCTVIEW_RES = 'DO_CORPORATECUSTOMIZEPRODUCTVIEW_RES';

export const DO_HOMEPAGESUBBANNER = 'DO_HOMEPAGESUBBANNER';
export const DO_HOMEPAGESUBBANNER_RES = 'DO_HOMEPAGESUBBANNER_RES';

export const DO_CSVUPLOAD = 'DO_CSVUPLOAD';
export const DO_CSVUPLOAD_RES = 'DO_CSVUPLOAD_RES';

export const DO_SHOWBILLING = 'DO_SHOWBILLING';
export const DO_SHOWBILLING_RES = 'DO_SHOWBILLING_RES';

export const DO_BILLINGUPDATE = 'DO_BILLINGUPDATE';
export const DO_BILLINGUPDATE_RES = 'DO_BILLINGUPDATE_RES';